import {
  type NewsItem,
  type NewsItemOld,
} from 'hb-react/frontoffice/apps/NewsIndex/utils/types';

// TODO: Remove this function when flagEvNewsRevamp is cleaned up
export const makeNewsItemBackwardCompatible = (
  item: NewsItem | NewsItemOld,
): NewsItemOld => {
  if ('newCoverPicture' in item) {
    return item;
  }

  return {
    categories: [],
    pinned: false,
    content: item.content,
    feedableAt: item.publishedAt,
    id: item.id,
    newCoverPicture: item.coverPicture,
    publishedAt: item.publishedAt,
    subject: item.subject,
    seoTitle: item.seoTitle,
    seoDescription: item.seoDescription,
  };
};
